import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateNativeData(state, { data }) {
      // state.fund = data;
      Vue.set(state, 'fund', data);
    },
    updateOpenTimeData(state, { data }) {
      state.time = data;
    },
  },
  actions: {
    updateNativeData({ commit }, nativeData) {
      return new Promise((resolve) => {
        commit('updateNativeData', {
          data: nativeData,
        });
        resolve(nativeData);
      });
    },
    updateOpenTimeData({ commit }, nativeData) {
      return new Promise((resolve) => {
        commit('updateOpenTimeData', {
          data: nativeData,
        });
        resolve(nativeData);
      });
    },
  },
  getters: {},
};
